// Б.1.d: Раст passive.
// «Каждый ТВОЙ юнит при появлении на поле получает случайную модификацию».
// Б.1.d-fix1: срабатывает ТОЛЬКО на юнитов СОБСТВЕННОЙ стороны Раста.
// Если оба игрока — Раст, каждый Раст работает только на свою сторону → у каждого
// призванного юнита ровно 1 Мод (от Раста-владельца).
// Урон Герою от прогрессии НЕ применяется (это пассивка Героя, не розыгрыш игроком).
// Бишор-trigger срабатывает только если Раст вешает Мод на юнита Бишора (через attachMod).

import { cards as cardsSyn } from '../../../data/cards-syntetics.js';

export const HERO_ID = 'syn_rast';

// attachModFn — функция attachMod, передаётся из регистратора (избегаем циклического импорта).
export function rastOnAnyUnitSummoned(state, summonedCard, attachModFn) {
  if (!summonedCard || summonedCard.type !== 'unit') return;
  const pool = cardsSyn.filter(c => c.type === 'mod');
  if (pool.length === 0) return;
  for (const owner of state.players) {
    if (owner.hero?.id !== HERO_ID) continue;
    if (owner.hero.hp <= 0) continue;
    // Б.1.d-fix1: Раст работает только на СВОИХ юнитов.
    if (owner.id !== summonedCard.ownerId) continue;
    if (!summonedCard.isAlive()) return;
    const tpl = pool[state.rng.int(pool.length)];
    state.log.add(`✨ Раст [${owner.name}]: ${summonedCard.name_ru} получает Мод ${tpl.name_ru}`);
    attachModFn(state, summonedCard, { id: tpl.id, name_ru: tpl.name_ru }, {
      heroId: HERO_ID, ownerIdx: owner.id
    });
  }
}
